/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/actions/activeSectores.actions.js
 * File: activeSectores.actions.js
 * Created Date: Monday, February 25th 2019, 2:27:41 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Mar 06 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

export const SET_ACTIVE_PROJECT = '[PROJECT] SET ACTIVE PROJECT'
export const SET_ACTIVE_DOCUMENT = '[DOCUMENT_VIEWER] SET ACTIVE DOCUMENT'

export function setActiveProject (id, token, name, star) {
  return {
    type: SET_ACTIVE_PROJECT,
    data: {
      id,
      token,
      name,
      star
    }
  }
}

export function setActiveDocument (id, token, name, star, index, data) {
  return {
    type: SET_ACTIVE_DOCUMENT,
    data: {
      id,
      token,
      name,
      star,
      index,
      data
    }
  }
}
